import { Navigate } from 'react-router'

import { useRouteCompanyId } from '@/hooks/use-route-company-id'
import { useRouteProjectId } from '@/hooks/use-route-project-id'

export function ProjectParamRouteGuard({
  children,
}: {
  children: React.ReactNode
}) {
  const companyId = useRouteCompanyId()!
  const projectId = useRouteProjectId()

  if (!projectId) {
    return <Navigate to={`/companies/${companyId}/projects`} replace />
  }

  return children
}
